<template>
  <div>
    <SectionTitle>Certificações</SectionTitle>

      <UserProfileCertificatesIndex
        :user="user"
        :per-page="4"
        :once="true"
        type="desktop"
      >
        <template v-slot:append="{ certificates }">
          <div class="text-center pt-5 pb-4" v-if="certificates.length >= 4">
            <TextButton @click="showUserCertificates">ver todos os certificados</TextButton>
          </div>
        </template>
      </UserProfileCertificatesIndex>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getCertificatesByUser } from '@/api/certificate.api'
import SectionTitle from '@/components/text/titles/SectionTitle'
import TextButton from '../../buttons/TextButton.vue'
import UserProfileCertificatesIndex from './UserProfileCertificatesIndex.vue'

export default {
  components: {
    SectionTitle,
    TextButton,
    UserProfileCertificatesIndex,
  },

  props: {
    user: { type: Object, required: true }
  },

  data: () => ({
    isLoading: false,
  }),

  methods: {
    ...mapActions('slideSidebar', ['slideSidebarShow']),
  
    async fetchCertificates () {
      const response = await getCertificatesByUser(this.user.id)
      this.certificates = response.data.data
    },

    showUserCertificates () {
      this.slideSidebarShow({
        name: 'user/UserCertificatesSidebar',
        direction: 'right',
        props: { user: this.user }
      })
    }
  }
}
</script>